<template>
    <div>
        <AIControl v-if="pageType === 'boardMode'" />
        <AIEyes v-if="pageType === 'aiEyes'" />
    </div>
</template>

<script>
import AIControl from "./ctrIndex.vue";
import AIEyes from "./AIEyes/index.vue";

export default {
    components: {
        AIControl,
        AIEyes,
    },
    data() {
        return {
            urlConfig: {},
            pageType: 'boardMode',
        };
    },
};
</script>
